import { useEffect } from 'react';
import type { InteractionParams, InteractionType } from '@lmn/common-search-widget/utilities/tracking/types';
import { CSW_INTERACTION_EVENT } from '@lmn/common-search-widget/utilities/tracking/constants';
import { NOOP } from './constants';

const isCSWInteractionEvent = <T extends InteractionType>(event: Event): event is CustomEvent<InteractionParams<T>> =>
  event instanceof CustomEvent && 'type' in event.detail;

const useInteractionEvents = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return NOOP;

    const handleInteraction = (event: Event) => {
      if (!isCSWInteractionEvent(event)) return;
      const { payload, type } = event.detail;
      // TODO: handle interaction events as you wish
      console.log('csw:interaction', type, payload);
    };

    window.addEventListener(CSW_INTERACTION_EVENT, handleInteraction, { passive: true });
    return () => window.removeEventListener(CSW_INTERACTION_EVENT, handleInteraction);
  }, []);
};

export default useInteractionEvents;
